import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ld_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STAGES = [
  { value: "lead", label: "Lead", className: "stage-lead" },
  { value: "qualified", label: "Qualified", className: "stage-qualified" },
  { value: "demo", label: "Demo", className: "stage-demo" },
  { value: "proposal", label: "Proposal", className: "stage-proposal" },
  { value: "closed", label: "Closed", className: "stage-closed" },
  { value: "lost", label: "Lost", className: "stage-lost" },
];

export const ESTAB_TYPES = [
  { value: "restaurant", label: "Restaurant", icon: "Utensils" },
  { value: "bar", label: "Bar", icon: "Wine" },
  { value: "liquor_store", label: "Liquor Store", icon: "Store" },
];

export function stageMeta(stage) {
  return STAGES.find((s) => s.value === stage) || STAGES[0];
}

export function typeMeta(t) {
  return ESTAB_TYPES.find((x) => x.value === t) || ESTAB_TYPES[0];
}
